import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportDownloadHistoryI } from '@interfaces/report-download-history.interface';

@Injectable({
  providedIn: 'root',
})
export class ReportDownloadHistoryHttpService {
  constructor(private http: HttpClient) {}

  public get(url: string, params: HttpParams) {
    return this.http.get<{ data: ReportDownloadHistoryI[]; meta: { itemCount: number } }>(url, { params });
  }
}
